// ============================================= //
//                                               //
//              1checkout.js v4                  //
//                                               //
// ============================================= //

// ---------------------- UTIL FUNCTIONS ---------------------- //
class OneCheckoutUtil {

  constructor() {
    this.URL_PARAMS = new URLSearchParams(window.location.search);
  };

  // apiRequest(method, url, headers, data, success, error, complete=null, timeout=null) {
  //   var xhttp = new XMLHttpRequest();
  //   var timedOut = false;
  //   if (timeout) {
  //     xhttp.timeout = timeout;
  //   }
  //   xhttp.open(method, url, true);
  //   headers.forEach(header => {
  //     xhttp.setRequestHeader(header[0], header[1]);
  //   });
  //   xhttp.onreadystatechange = function () {
  //     if (xhttp.readyState === 4) {
  //       if(timedOut)
  //         return;
  //       if (xhttp.status === 0 && timeout) {
  //         // Let ontimeout handler manage this case
  //         return;
  //       }
  //       if (xhttp.status === 200) {
  //         success(JSON.parse(this.responseText));
  //       } else {
  //         try{
  //           if (error.length > 1) { // Check if the error callback expects a status parameter
  //             error(JSON.parse(this.responseText), xhttp.status);
  //           } else {
  //               error(JSON.parse(this.responseText));
  //           }
  //         }catch(parseError){
  //           if (!timedOut) {
  //             console.log(parseError);
  //             if (error.length > 1) {
  //               error({}, xhttp.status);
  //             } else {
  //               error();
  //             }
  //           }
  //         }
  //       };
  //       if (complete) {
  //         complete();
  //       };
  //     };
  //   };
  //   if (timeout) {
  //     xhttp.ontimeout = function () {
  //       timedOut = true;
  //       if (typeof error === 'function') {
  //         if (error.length > 1) {
  //           error({message: 'timeout'}, 0);
  //         } else {
  //           error({message: 'timeout'});
  //         }
  //       }
  //       if (complete) {
  //         complete();
  //       }
  //     };
  //   }
  //   xhttp.send(JSON.stringify(data));
  // };

  apiRequest(method, url, headers, data, success, error, complete = null, timeout = null, retries = 0) {
    const xhttp = new XMLHttpRequest();
    const self = this;
    let timerId;
    let requestHandled = false;
    const remainingRetries = Number(retries) || 0;
  
    xhttp.open(method, url, true);
    headers.forEach(header => {
      xhttp.setRequestHeader(header[0], header[1]);
    });
  
    if (timeout) {
      timerId = setTimeout(() => {
        if (requestHandled) return;
        requestHandled = true;
        // Abort the in-flight request so timeout handling is single-shot.
        try {
          xhttp.abort();
        } catch (abortErr) {}
        if (remainingRetries > 0) {
          self.apiRequest(method, url, headers, data, success, error, complete, timeout, remainingRetries - 1);
          return;
        }
        if (typeof error === 'function') {
          if (error.length > 1) error({ message: 'timeout' }, 0);
          else             error({ message: 'timeout' });
        }
        if (complete) complete();
      }, timeout);
    }
  
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState !== 4) return;
      if (requestHandled) return;
      requestHandled = true;
  
      if (timerId) clearTimeout(timerId);
  
      if (xhttp.status === 200) {
        success(JSON.parse(this.responseText));
      } else {
        const shouldRetry =
          remainingRetries > 0 &&
          (xhttp.status === 0 || xhttp.status === 408 || xhttp.status === 429 || xhttp.status >= 500);
        if (shouldRetry) {
          self.apiRequest(method, url, headers, data, success, error, complete, timeout, remainingRetries - 1);
          return;
        }
        try {
          if (error.length > 1) error(JSON.parse(this.responseText), xhttp.status);
          else                  error(JSON.parse(this.responseText));
        } catch (parseErr) {
          console.log(parseErr);
          if (error.length > 1) error({}, xhttp.status);
          else                  error();
        }
      }
  
      if (complete) complete();
    };
  
    xhttp.send(JSON.stringify(data));
  };

  set1CheckoutLocalStorage(key, value, expiry_hrs) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry_hrs*60*60*1000));
    expires = expires.toUTCString();

    localStorage.setItem(key, JSON.stringify({
      value: value,
      expires: expires}));
  };

  get1CheckoutLocalStorage(key) {
    try {
      var _data = JSON.parse(localStorage.getItem(key));
      var now = (new Date()).getTime();
      var expires = Date.parse(_data.expires);
      
      if (expires > now) {
        return _data.value;
      } else {
        this.delete1CheckoutLocalStorage(key);
        return null;
      }
    } catch (err) {
      return null;
    };
  };

  delete1CheckoutLocalStorage(key) {
    localStorage.removeItem(key);
  };

  get1CheckoutCookie(key) {
    for (var o = key + "=", r = decodeURIComponent(document.cookie).split(";"), n = 0; n < r.length; n++) {
      for (var t = r[n];
        " " == t.charAt(0);) t = t.substring(1);
      if (0 == t.indexOf(o)) return t.substring(o.length, t.length)
    };
    return null;
  };

  seedFbcCookieFromFbclid() {
    // When the landing URL carries ?fbclid=, store/refresh the _fbc cookie in
    // Meta's own format (fb.1.<capture time ms>.<fbclid>) so CAPI events carry
    // a real fbc with a truthful timestamp instead of a backend-fabricated
    // one. Mirrors the Meta pixel: a new click id always replaces the cookie;
    // without a new fbclid an existing cookie is left untouched.
    try {
      var fbclid = new URL(window.location.href).searchParams.get('fbclid');
      if (!fbclid) return;
      var existing = this.get1CheckoutCookie('_fbc');
      // fbclid is everything after the third dot of fb.<ver>.<ts>.<fbclid>
      if (existing && existing.split('.').slice(3).join('.') === fbclid) return;
      var domain = window.location.hostname.replace(/^www\./, '');
      document.cookie = '_fbc=fb.1.' + Date.now() + '.' + fbclid +
        '; max-age=' + 90 * 24 * 3600 + '; domain=.' + domain + '; path=/; SameSite=Lax';
    } catch (err) {};
  };

  getAllParams(){
    var url = new URL(window.location.href);

    var queryParams = url.searchParams;
    
    var params = {};

    queryParams.forEach(function (value, key) {
      params[key] = value;
    });

    if (queryParams.toString() !== "") {
      let existingParams = this.get1CheckoutLocalStorage('queryparams_1c') || {};
      this.set1CheckoutLocalStorage('queryparams_1c', {...existingParams, ...params}, 24*7);
    } else {
      params = this.get1CheckoutLocalStorage('queryparams_1c');
    }

    return params || {};
  };

};
// ---------------------- UTIL FUNCTIONS ---------------------- //

// ---------------------- CONSTANTS ---------------------- //
const ONE_CHECKOUT_UTIL = new OneCheckoutUtil();
ONE_CHECKOUT_UTIL.seedFbcCookieFromFbclid();
const IS_DEMO_1C_PAGE = false;
const API_HOST_1C = 'https://api.1checkout.ai';
const HOST_1C = 'https://pay.1checkout.ai';
const API_KEY_1C = 'c92cfb4c-69f7-4f22-aaac-f048d88eaddd';
const IS_1C_ENABLED = !ONE_CHECKOUT_UTIL.get1CheckoutLocalStorage('d1c') && true;
// ---------------------- CONSTANTS ---------------------- //

// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //
class OneCheckoutBtnRenderer {

  constructor(targetBtns, logMutations=false) {
    if (IS_1C_ENABLED)
      this.targetBtns = targetBtns;
    else
      this.targetBtns = [];
    
    this.logMutations = logMutations;

    // Remove btnMeta if not applicable for current page
    var pageObserverRequired = false;
    var _tempTargetBtnsFor1C = [];
    this.targetBtns.forEach(btnMeta => {
      if (btnMeta.urlPattern) {
        if (window.location.pathname.includes(btnMeta.urlPattern))
          _tempTargetBtnsFor1C.push(btnMeta);
      } else {
        _tempTargetBtnsFor1C.push(btnMeta);
      };
    });
    this.targetBtns = _tempTargetBtnsFor1C;

    this.targetBtns.forEach(btnMeta => {
      // Hide all static targets before page loads
      this.hide1CTarget(btnMeta);
      // Check if page observer will be required
      if (btnMeta.pageObserver) pageObserverRequired = true;
    });

    // Create all button observers
    this.BTN_OBSERVERS = [];
    this._obsConfig = { childList: true, subtree: true };
    this._obsCallback = (mutationsList, observer) => {
      // Fetch the btnMeta for observer
      var _btnMeta;
      var _observer;
      this.BTN_OBSERVERS.forEach(o => {
        if (o.observer == observer) {
          _btnMeta = o.btnMeta;
          _observer = o.observer;
        };
      });
      // Check for all mutations and replace the button
      for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (this.logMutations)
              console.log(node);
            if (node.nodeName == _btnMeta.observeForBtn.nodeName && node.getAttribute(_btnMeta.observeForBtn.nodeAttr) == _btnMeta.observeForBtn.nodeAttrVal) {
              this.hide1CTarget(_btnMeta, node);
              this.render1CBtn(_btnMeta, node);
              if (_btnMeta.observeForBtn.stopObservingWhenFound) _observer.disconnect();
              return;
            };
          });
        };
      };
    };

    // Create all url observers
    this.targetBtns.forEach(btnMeta => {
      if (btnMeta.observeUrl) this.initUrlObserver(btnMeta);
    });
    
    // Create all button observers
    this.targetBtns.forEach(btnMeta => {
      if (btnMeta.observeForBtn) this.initBtnObserver(btnMeta);
    });

    // Create all pagination observers
    this.paginationObserver;
    if (pageObserverRequired) this.initPageObserver();
  };

  hide1CTarget(btnMeta, container=null) {
    var root = container || document;
    var selector = btnMeta.hideInstead || btnMeta.selector;
    if (!selector) return;

    if (btnMeta.extendedMode === 'all') {
      var targets = root.querySelectorAll(selector);
      targets.forEach(el => {
        el.classList.add('dc-none');
      });
      return;
    };

    var el = root.querySelector(selector);
    if (el) el.classList.add('dc-none');
  };
  
  render1CBtn(btnMeta, container=null) {
    var root = container || document;
    if (!btnMeta.selector) return;

    if (btnMeta.extendedMode === 'all') {
      var targets = root.querySelectorAll(btnMeta.selector);
      targets.forEach((btn, index) => {
        if (!btn || !btn.parentElement) return;

        var sibling1C =
          btn.previousElementSibling?.classList?.contains('btn-group-1checkout') ||
          btn.nextElementSibling?.classList?.contains('btn-group-1checkout');
        if (sibling1C) return;

        var checkoutBtnContainer = document.createElement('div');
        checkoutBtnContainer.setAttribute('class', 'btn-group-1checkout');
        checkoutBtnContainer.setAttribute('data-1c-extended', 'true');
        checkoutBtnContainer.setAttribute('data-1c-target-index', String(index));
        checkoutBtnContainer.innerHTML = btnMeta.dynamicBtn;

        checkoutBtnContainer.querySelectorAll('[id]').forEach(node => {
          node.id = `${node.id}__1c_${index}`;
        });

        if(btnMeta.siblingPosition == "before"){
          btn.before(checkoutBtnContainer);
        }else{
          btn.after(checkoutBtnContainer);
        };
      });
      return;
    };

    var btn = root.querySelector(btnMeta.selector);
    if (btn) {
      if (container) {
        if (container.getElementsByClassName('btn-group-1checkout').length > 0) return;
      } else {
        if (!btn.parentElement) return;
        if (btn.parentElement.getElementsByClassName('btn-group-1checkout').length > 0) return;
      };

      var checkoutBtnContainer = document.createElement('div');
      checkoutBtnContainer.setAttribute('class', 'btn-group-1checkout');
      checkoutBtnContainer.innerHTML = btnMeta.dynamicBtn;
      if(btnMeta.siblingPosition == "before"){
        btn.before(checkoutBtnContainer);
      }else{
        btn.after(checkoutBtnContainer);
      };
    };
  };

  initBtnObserver(btnMeta) {
    var observer = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    if (observer) {
      var containers = document.querySelectorAll(btnMeta.observeForBtn.container);
      containers.forEach(container => {
        var _observer = new observer(this._obsCallback);
        _observer.observe(container, this._obsConfig);
        this.BTN_OBSERVERS.push({
          btnMeta: btnMeta,
          observer: _observer
        });
      });
    };
  };

  initUrlObserver(btnMeta) {
    var observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.initiatorType === "fetch") {
          if (entry.name.includes(btnMeta.observeUrl)) {
            this.hide1CTarget(btnMeta);
            this.render1CBtn(btnMeta);
          };
        };
      };
    });
  
    observer.observe({
      entryTypes: ["resource"]
    });
  };
  
  initPageObserver() {
    this.paginationObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.initiatorType === "fetch") {
          if (entry.name.includes('page=')) {
            this.targetBtns.forEach(btnMeta => {
              if (btnMeta.observeForBtn) this.initBtnObserver(btnMeta);
  
              if (btnMeta.observeEvent) {
                var targets = document.querySelectorAll(btnMeta.observeEvent.target);
                targets.forEach(target => {
                  target.addEventListener(btnMeta.observeEvent.event, function() {
                    this.hide1CTarget(btnMeta);
                    this.render1CBtn(btnMeta);
                  });
                });
              };
            });
          };
        };
      };
    });
  
    this.paginationObserver.observe({
      entryTypes: ["resource"]
    });
  };

  pageLoad() {
    // On page load, dynamically add 1Checkout btns which need not be observed
    this.targetBtns.forEach(btnMeta => {
      this.render1CBtn(btnMeta);

      if (btnMeta.observeEvent) {
        var targets = document.querySelectorAll(btnMeta.observeEvent.target);
        targets.forEach(target => {
          target.addEventListener(btnMeta.observeEvent.event, function() {
            oneCheckoutBtnRenderer.hide1CTarget(btnMeta);
            oneCheckoutBtnRenderer.render1CBtn(btnMeta);
          });
        });
      };
    });
  };

};
// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //

// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //
class OneCheckout {

  constructor() {
    // --- VARIABLES & CONSTS
    this.CHECKOUT_CLIENT_IP_ADDRESS = null;
    try {
      fetch('https://api64.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          try {
            this.CHECKOUT_CLIENT_IP_ADDRESS = data.ip
          } catch (error) {};
        });
    } catch (error) {};
    this.API_HEADERS = [
      ['Content-type', 'application/json'],
      ['X-LOGISY-API-KEY', API_KEY_1C]
    ];
    this.CHECKOUT_ID;
    // var VISITOR_COUNTRY_CODE = null;
    this.TRIGGER_1CHECKOUT = ONE_CHECKOUT_UTIL.URL_PARAMS.get('t1c');
    this.TRIGGER_1CHECKOUT = String(this.TRIGGER_1CHECKOUT || '').toLowerCase() == 'true' && IS_1C_ENABLED;
    this.REFRESH_CART = ONE_CHECKOUT_UTIL.URL_PARAMS.get('refresh');
    this.REFRESH_CART = String(this.REFRESH_CART || '').toLowerCase() == 'true';
    this.PAGE_LOADED = false;
    this.CHECKOUT_CART = {
      getCartItemCount: function() {
        var count = 0;
        this.CHECKOUT_CART.items.forEach(item => {
          count += item.quantity;
        });
        return count;
      },
      getCartItemDetails: function() {
        var items = [];
        this.CHECKOUT_CART.items.forEach(item => {
          items.push({
            id: item.id.toString(),
            quantity: item.quantity,
            name: item.title
          });
        });
        return items;
      },
      getCartProductIds: function() {
        var ids = [];
        this.CHECKOUT_CART.items.forEach(item => {
          ids.push(item.product_id.toString());
        });
        return ids;
      }
    };

    this.loaderMessages1Checkout = [
      'Carefully wrapping your items',
      'Crossing T’s & dotting I’s',
      'Juuust a moment..',
      'Adding the cherry on top'
    ];
    this.loaderMessagesTimer = null;
    this.progressCrawlTimer = null;
    this.iframeLoadTimer = null;
    this._messageIdx = 0;
    this.CHECKOUT_URL;
    this.CHECKOUT_ERROR = false;
    this.ERROR_OCCURRED = false;
    this.PAGE_LIFECYCLE_BOUND = false;
    this._lastTimeoutErrorTs = 0;
    this._bodyScrollLockState = null;
    this.SHOPIFY_EVENT_CONFIG = {
      checkout_started: {
        shopifyName: 'pragma_events',
        payloadName: 'Started_Checkout_Pragma',
      },
      mobile_added: {
        shopifyName: 'pragma_events',
        payloadName: 'Mobile_Added_Pragma',
      },
      address_step_reached: {
        shopifyName: 'pragma_events',
        payloadName: 'Address_Step_Reached_Pragma',
      },
      address_added: {
        shopifyName: 'pragma_events',
        payloadName: 'Address_Added_Pragma',
      },
      payment_step_reached: {
        shopifyName: 'pragma_events',
        payloadName: 'Payment_Step_Reached_Pragma',
      },
      order_purchased: {
        shopifyName: 'pragma_events',
        payloadName: 'Order_Purchased_Pragma',
      }
    };
    this.resetShopifyCustomerEventState();

    this.QUERY_PARAMS_1C = ONE_CHECKOUT_UTIL.getAllParams();

    // --- EXTERNAL TRIGGERS
    if (this.TRIGGER_1CHECKOUT) {
      // Showing overlay here but 1checkout triggered after cart is updated
      // document.body.style.overflow = 'hidden';
      var loader = '<span style="position: absolute; border: 3px solid #fff; border-top: 3px solid #0000; border-radius: 50%; width: 32px; height: 32px; left: calc(50% - 16px); top: calc(50% - 16px)"></span>';
      var overlay = `<div id="checkoutRedirectOverlay" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,0.9); z-index: 1063;">${loader}<p style="position: absolute;left: calc(50% - 75px);top: 53%;color: white;">Loading your cart items..... </p></div>`;
      document.querySelector('body').innerHTML += overlay;
      document.querySelector('#checkoutRedirectOverlay span').animate(
        [{transform: `rotate(360deg)`}],
        {
          duration: 1000,
          iterations: Infinity
        });
      // document.getElementById('checkoutModal').checked = true;
      // document.querySelector('.checkout-progressbar').classList.remove('dc-none');
      // this.startLoaderMessages();
    };
    if (!this.TRIGGER_1CHECKOUT && this.REFRESH_CART) {
      // Show only overlay till cart is updated and page is refreshed
      var loader = '<span style="position: absolute; border: 3px solid #fff; border-top: 3px solid #0000; border-radius: 50%; width: 32px; height: 32px; left: calc(50% - 16px); top: calc(50% - 16px)"></span>';
      var overlay = `<div id="checkoutRedirectOverlay" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,0.9); z-index: 1063;">${loader}</div>`;
      document.querySelector('body').innerHTML += overlay;
      document.querySelector('#checkoutRedirectOverlay span').animate(
        [{transform: `rotate(360deg)`}],
        {
          duration: 1000,
          iterations: Infinity
        });
    };
  };

  getInitialShopifyCustomerEventState() {
    return {
      published: {},
      cartToken: null,
      attributes: {},
      products: [],
      totalPrice: null,
      originalCartPrice: null,
      currency: 'INR',
      couponCode: '',
      totalDiscountApplied: 0,
      mobileNumber: '',
      address: null,
      shippingMethod: '',
      prefilledAddress: null,
      abandonedUrl: '',
      checkoutId: null,
      checkoutUrl: null,
      orderId: null,
    };
  };

  resetShopifyCustomerEventState() {
    this.SHOPIFY_CUSTOMER_EVENTS = this.getInitialShopifyCustomerEventState();
  };

  getCustomerEventErrorMessage(err, fallback = 'Unable to continue with checkout.') {
    if (err && typeof err === 'object') {
      const message = err.description || err.message || err.error || err.detail;
      if (message) {
        return String(message);
      }
    }
    if (typeof err === 'string' && err.trim()) {
      return err;
    }
    return fallback;
  };

  getShopifyAnalyticsPublisher() {
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      return window.Shopify.analytics.publish.bind(window.Shopify.analytics);
    }
    return null;
  };

  readCookie(name) {
    return ONE_CHECKOUT_UTIL.get1CheckoutCookie(name);
  };

  normalizeCustomerEventMoney(value, fallback = 0) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) {
      return fallback;
    }
    return Number(parsed.toFixed(2));
  };

  moneyFromShopifyCents(value, fallback = 0) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) {
      return fallback;
    }
    return Number((parsed / 100).toFixed(2));
  };

  getFirstPresentValue(values = [], fallback = '') {
    for (const value of values) {
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
    return fallback;
  };

  coerceCustomerEventId(value) {
    if (value === undefined || value === null || value === '') {
      return '';
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : String(value);
  };

  formatCustomerEventPhone(phone) {
    const normalizedPhone = String(phone || '').trim();
    if (!normalizedPhone) {
      return '';
    }
    if (normalizedPhone.startsWith('+')) {
      return normalizedPhone;
    }
    const digitsOnly = normalizedPhone.replace(/\D/g, '');
    if (digitsOnly.length === 10) {
      return `+91${digitsOnly}`;
    }
    return normalizedPhone;
  };

  buildCustomerEventProducts(items = [], currency = 'INR') {
    if (!Array.isArray(items)) {
      return [];
    }

    return items.map((item) => {
      const quantity = Number(item.quantity) || 0;
      const linePriceCents = this.getFirstPresentValue(
        [
          item.final_line_price,
          item.line_price,
          item.original_line_price,
        ],
        null
      );
      const derivedUnitPriceCents =
        quantity > 0 && linePriceCents !== null && linePriceCents !== undefined
          ? Number(linePriceCents) / quantity
          : null;
      const unitPrice = this.moneyFromShopifyCents(
        this.getFirstPresentValue(
          [
            item.final_price,
            item.discounted_price,
            item.price,
            item.original_price,
            derivedUnitPriceCents,
            item.presentment_price,
          ],
          0
        ),
        0
      );
      const optionValues = Array.isArray(item.options_with_values)
        ? item.options_with_values
            .map((option) => option && option.value)
            .filter(Boolean)
        : [];
      const variantOptions = Array.isArray(item.variant_options)
        ? item.variant_options.filter(Boolean)
        : [];
      const rawVariantText =
        item.variant_title ||
        item.variant_name ||
        item.variant ||
        optionValues.join(' / ') ||
        variantOptions.join(' / ') ||
        '';
      const variantText =
        rawVariantText && rawVariantText !== 'Default Title' ? rawVariantText : '';
      const imageUrl =
        (typeof item.image === 'string' && item.image) ||
        (item.image && item.image.src) ||
        (item.featured_image && item.featured_image.url) ||
        (item.featured_image && item.featured_image.src) ||
        item.image_url ||
        '';
      const productUrl = item.url || item.product_url || '';

      return {
        'Product ID': this.coerceCustomerEventId(item.product_id),
        'Product Name': item.product_title || item.title || '',
        'Product Price': unitPrice,
        'Product Quantity': quantity,
        'Product Variant Id': this.coerceCustomerEventId(
          item.variant_id || item.id
        ),
        Currency: currency || 'INR',
        'Image Url': imageUrl,
        'Product Url': productUrl,
        Variants: variantText,
      };
    });
  };

  getShopifyCartCouponCode(cartJson = {}) {
    if (Array.isArray(cartJson.discount_codes) && cartJson.discount_codes.length > 0) {
      const discountCode = cartJson.discount_codes
        .map((discount) => discount && (discount.code || discount.title))
        .filter(Boolean)[0];
      if (discountCode) {
        return discountCode;
      }
    }

    if (
      Array.isArray(cartJson.cart_level_discount_applications) &&
      cartJson.cart_level_discount_applications.length > 0
    ) {
      const cartDiscount = cartJson.cart_level_discount_applications
        .map((discount) => discount && (discount.code || discount.title))
        .filter(Boolean)[0];
      if (cartDiscount) {
        return cartDiscount;
      }
    }

    if (Array.isArray(cartJson.items)) {
      const lineDiscount = cartJson.items
        .flatMap((item) => Array.isArray(item.discounts) ? item.discounts : [])
        .map((discount) => discount && (discount.code || discount.title))
        .filter(Boolean)[0];
      if (lineDiscount) {
        return lineDiscount;
      }
    }

    return this.SHOPIFY_CUSTOMER_EVENTS.couponCode || '';
  };

  setShopifyCartContext(cartJson = {}, originalCartToken = null) {
    const products = this.buildCustomerEventProducts(
      Array.isArray(cartJson.items) ? cartJson.items : [],
      cartJson.currency || this.SHOPIFY_CUSTOMER_EVENTS.currency || 'INR'
    );
    const attributes =
      cartJson.attributes && typeof cartJson.attributes === 'object'
        ? { ...cartJson.attributes }
        : {};
    const shopifyVisitorId = this.readCookie('_shopify_y');

    if (shopifyVisitorId && !attributes._y) {
      attributes._y = shopifyVisitorId;
    }

    this.updateShopifyCustomerEventState({
      cartToken:
        cartJson.token ||
        cartJson.cart_token ||
        originalCartToken ||
        this.SHOPIFY_CUSTOMER_EVENTS.cartToken,
      attributes,
      products,
      totalPrice: this.moneyFromShopifyCents(
        cartJson.total_price ?? cartJson.items_subtotal_price ?? 0,
        this.SHOPIFY_CUSTOMER_EVENTS.totalPrice || 0
      ),
      originalCartPrice: this.moneyFromShopifyCents(
        cartJson.original_total_price ??
          cartJson.items_subtotal_price ??
          cartJson.total_price ??
          0,
        this.SHOPIFY_CUSTOMER_EVENTS.originalCartPrice || 0
      ),
      currency:
        cartJson.currency ||
        window.Shopify?.currency?.active ||
        this.SHOPIFY_CUSTOMER_EVENTS.currency ||
        'INR',
      couponCode: this.getShopifyCartCouponCode(cartJson),
      totalDiscountApplied: this.moneyFromShopifyCents(
        cartJson.total_discount ??
          cartJson.total_discounts ??
          cartJson.total_discount_applied ??
          0,
        this.SHOPIFY_CUSTOMER_EVENTS.totalDiscountApplied || 0
      ),
    });

  };

  updateShopifyCustomerEventState(fragment = {}) {
    if (!fragment || typeof fragment !== 'object') {
      return;
    }

    if (fragment.address && typeof fragment.address === 'object') {
      this.SHOPIFY_CUSTOMER_EVENTS.address = {
        ...(this.SHOPIFY_CUSTOMER_EVENTS.address || {}),
        ...fragment.address,
      };
    }

    Object.keys(fragment).forEach((key) => {
      if (key === 'address') {
        return;
      }
      const value = fragment[key];
      if (value === undefined) {
        return;
      }
      this.SHOPIFY_CUSTOMER_EVENTS[key] = value;
    });
  };

  getPublishedShopifyEventKey(eventKey) {
    const checkoutId =
      this.SHOPIFY_CUSTOMER_EVENTS.checkoutId ||
      this.CHECKOUT_ID ||
      'pending_checkout';
    return `${checkoutId}:${eventKey}`;
  };

  buildCustomerEventAddressLine(address = {}) {
    return [
      address.address,
      address.landmark,
      address.city,
      address.state,
      address.country,
      address.pin,
    ]
      .map((value) => String(value || '').trim())
      .filter(Boolean)
      .join(', ');
  };

  buildShopifyCustomerEventPayload(eventKey) {
    const config = this.SHOPIFY_EVENT_CONFIG[eventKey];
    if (!config) {
      return null;
    }

    const state = this.SHOPIFY_CUSTOMER_EVENTS;
    const products = Array.isArray(state.products) ? state.products : [];
    const address = state.address || {};
    const payload = {
      Tag: 'Pragma Checkout',
      total_price: this.normalizeCustomerEventMoney(
        state.totalPrice,
        this.normalizeCustomerEventMoney(state.originalCartPrice, 0)
      ),
      'Original Cart Price': this.normalizeCustomerEventMoney(
        state.originalCartPrice,
        this.normalizeCustomerEventMoney(state.totalPrice, 0)
      ),
      currency: state.currency || 'INR',
      source: 'Web',
      'Coupon Code': state.couponCode || '',
      'Landing Page': `${window.location.pathname}${window.location.search}`,
      'Origin Referrer': document.referrer || '',
      'Total Discount Applied': this.normalizeCustomerEventMoney(
        state.totalDiscountApplied,
        0
      ),
      shopify_session_id: this.readCookie('_shopify_s') || null,
      'Time Stamp': Date.now(),
      Products: products,
      cart_token: state.cartToken || '',
      attributes:
        state.attributes && typeof state.attributes === 'object'
          ? state.attributes
          : {},
    };

    if (eventKey !== 'checkout_started' && state.mobileNumber) {
      payload['Mobile Number'] = this.formatCustomerEventPhone(state.mobileNumber);
    }

    if (eventKey !== 'checkout_started' && (state.abandonedUrl || state.checkoutUrl)) {
      payload['Abandoned URL'] = state.abandonedUrl || state.checkoutUrl;
    }

    if (eventKey === 'order_purchased' && state.orderId) {
      payload.order_id = state.orderId;
      payload['Order Number'] = state.orderId;
    }

    if (
      eventKey === 'address_added' ||
      eventKey === 'payment_step_reached' ||
      eventKey === 'order_purchased'
    ) {
      if (address.fullName) {
        const nameParts = String(address.fullName).trim().split(/\s+/);
        payload['First Name'] = nameParts[0] || '';
        payload['Last Name'] =
          nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
      }
      if (address.email) {
        payload.Email = address.email;
      }
      if (address.address || address.landmark || address.city || address.state) {
        payload['Full Address'] = this.buildCustomerEventAddressLine(address);
      }
      if (address.city) {
        payload.City = address.city;
      }
      if (address.state) {
        payload.State = address.state;
      }
      if (address.country) {
        payload.Country = address.country;
      }
      if (address.region || address.city || address.state) {
        payload.Region = address.region || address.city || address.state;
      }
      if (address.pin) {
        const parsedPin = Number(address.pin);
        payload.Pincode = Number.isFinite(parsedPin) ? parsedPin : address.pin;
      }
      if (state.shippingMethod) {
        payload['Shipping Method'] = state.shippingMethod;
      }
      if (state.prefilledAddress !== null && state.prefilledAddress !== undefined) {
        payload['Gokwik Prefilled Address'] = state.prefilledAddress
          ? 'Yes'
          : 'No';
      }
    }

    payload['Product ID'] = products.map((product) => product['Product ID']);
    payload['Product Name'] = products.map((product) => product['Product Name']);
    payload['Product Quantity'] = products.map(
      (product) => product['Product Quantity']
    );
    payload['Product Variant ID'] = products.map(
      (product) => product['Product Variant Id']
    );
    payload['Product Price'] = products.map(
      (product) => product['Product Price']
    );
    payload['Product Image URL'] = products.map(
      (product) => product['Image Url']
    );
    payload['Product Url'] = products.map((product) => product['Product Url']);

    const wrappedPayload = {
      name: config.payloadName,
      data: {
        data: payload,
      },
    };

    return {
      // Shopify pixels reliably expose custom event data via event.customData.
      // Keep non-reserved aliases at the top level so the Web Pixels Manager
      // does not drop the payload while still preserving the expected wrapper.
      event_name: config.payloadName,
      event_data: payload,
      event_payload: wrappedPayload,
      pragma_payload_name: config.payloadName,
      name: config.payloadName,
      data: {
        data: payload,
      },
    };
  };

  mirrorShopifyCustomerEvent(config, payload) {
    if (!config || !payload) {
      return;
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: config.shopifyName,
        pragma_customer_event: payload.event_payload || {
          name: payload.name,
          data: payload.data,
        },
        pragma_payload_name: payload.pragma_payload_name || payload.name,
        pragma_event_data: payload.event_data || payload.data?.data || {},
      });
    } catch (error) {}

    try {
      window.dispatchEvent(
        new CustomEvent(config.shopifyName, {
          detail: payload,
        })
      );
    } catch (error) {}
  };

  publishShopifyCustomerEvent(eventKey, fragment = {}) {
    const config = this.SHOPIFY_EVENT_CONFIG[eventKey];
    if (!config) {
      return;
    }

    this.updateShopifyCustomerEventState(fragment);

    const publisher = this.getShopifyAnalyticsPublisher();
    if (!publisher) {
      return;
    }

    const publishedKey = this.getPublishedShopifyEventKey(eventKey);
    if (this.SHOPIFY_CUSTOMER_EVENTS.published[publishedKey]) {
      return;
    }

    const payload = this.buildShopifyCustomerEventPayload(eventKey);
    if (!payload) {
      return;
    }

    try {
      publisher(config.shopifyName, payload);
      this.mirrorShopifyCustomerEvent(config, payload);
      this.SHOPIFY_CUSTOMER_EVENTS.published[publishedKey] = true;
    } catch (error) {
      console.warn(`Shopify analytics publish failed for ${config.shopifyName}`, error);
    }
  };

  startLoaderMessages() {
    this.loaderMessagesTimer = setInterval(function() {
      document.getElementById('checkoutLoadingMessage').innerHTML = oneCheckout.loaderMessages1Checkout[oneCheckout._messageIdx];
      oneCheckout._messageIdx += 1;
      if (oneCheckout._messageIdx == oneCheckout.loaderMessages1Checkout.length) {
        oneCheckout.resetSplashScreen();
      };
    }, 1200);
  };

  resetProgressBarAnimation() {
    if (this.progressCrawlTimer) {
      clearTimeout(this.progressCrawlTimer);
      this.progressCrawlTimer = null;
    }

    const progressLine = document.querySelector('.checkout-progressbar .linewrap .line');
    if (!progressLine) return;

    progressLine.classList.remove('progress-crawl');
    progressLine.style.transition = 'none';
    progressLine.style.width = '0%';
    progressLine.offsetWidth;
    progressLine.style.transition = '';
  };

  startProgressBarAnimation() {
    const progressLine = document.querySelector('.checkout-progressbar .linewrap .line');
    if (!progressLine) return;

    this.resetProgressBarAnimation();

    requestAnimationFrame(() => {
      progressLine.style.width = '75%';
      this.progressCrawlTimer = setTimeout(() => {
        const activeLine = document.querySelector('.checkout-progressbar .linewrap .line');
        if (!activeLine) return;
        activeLine.classList.add('progress-crawl');
        activeLine.style.width = '100%';
      }, 400);
    });
  };

  resetSplashScreen() {
    // Reset splash screen
    clearInterval(this.loaderMessagesTimer);
    this.loaderMessagesTimer = null;
    this._messageIdx = 0;
    var loadingMessage = document.getElementById('checkoutLoadingMessage');
    if (loadingMessage) loadingMessage.innerHTML = 'Initializing...';
    this.resetProgressBarAnimation();
    document.querySelector('.checkout-progressbar')?.classList.add('dc-none');
  };

  clearIframeLoadWatchdog() {
    if (this.iframeLoadTimer) {
      clearTimeout(this.iframeLoadTimer);
      this.iframeLoadTimer = null;
    }
  };

  showCheckoutRetryMessage(message) {
    if (this.loaderMessagesTimer) {
      clearInterval(this.loaderMessagesTimer);
      this.loaderMessagesTimer = null;
    }
    var loadingMessage = document.getElementById('checkoutLoadingMessage');
    if (!loadingMessage) return;
    loadingMessage.innerHTML = message + '<br><button type="button" onclick="oneCheckout.initialize1Checkout()" style="margin-top: 12px; border: 0; border-radius: 6px; padding: 10px 16px; background: #111; color: #fff; font-weight: 600; cursor: pointer;">Retry checkout</button>';
    this.resetProgressBarAnimation();
    document.querySelector('.checkout-progressbar')?.classList.add('dc-none');
  };

  startIframeLoadWatchdog() {
    this.clearIframeLoadWatchdog();
    this.iframeLoadTimer = setTimeout(function() {
      oneCheckout.showCheckoutRetryMessage('Checkout is taking longer than expected.');
    }, 12000);
  };

  resetCheckoutModalState(options = {}) {
    this.clearIframeLoadWatchdog();
    const removeIframe = options.removeIframe !== false;
    const clearCheckoutContext = options.clearCheckoutContext === true;
    const modalToggle = document.getElementById('checkoutModal');
    const overlay = document.querySelector('.checkoutmodal .overlay');
    const splashScreen = document.querySelector('.checkoutmodal .splash-screen');
    const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');

    this.resetSplashScreen();

    if (modalToggle) {
      modalToggle.checked = false;
    }

    if (overlay) {
      overlay.classList.remove('dc-none');
    }

    if (splashScreen) {
      splashScreen.classList.remove('dc-none');
    }

    if (iframe) {
      iframe.classList.add('dc-none');
      if (removeIframe) {
        iframe.remove();
      }
    }

    this.unlockBodyScroll();

    if (clearCheckoutContext) {
      this.CHECKOUT_ID = null;
      this.CHECKOUT_URL = null;
      this.ERROR_OCCURRED = false;
      this.resetShopifyCustomerEventState();
    }
  };

  bindPageLifecycleGuards() {
    if (this.PAGE_LIFECYCLE_BOUND) return;
    this.PAGE_LIFECYCLE_BOUND = true;

    window.addEventListener('pagehide', () => {
      this.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
    });

    window.addEventListener('pageshow', (event) => {
      // Normal initial pageshow fires after load. Do not close an active checkout
      // that a user opened while slow page assets were still loading.
      if (event.persisted) {
        this.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
      }
    });
  };

  lockBodyScroll() {
    if (this._bodyScrollLockState) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;
    const bodyStyle = document.body.style;
    const htmlStyle = document.documentElement.style;

    this._bodyScrollLockState = {
      scrollY,
      bodyOverflow: bodyStyle.overflow,
      bodyPosition: bodyStyle.position,
      bodyTop: bodyStyle.top,
      bodyWidth: bodyStyle.width,
      htmlOverflow: htmlStyle.overflow,
    };

    htmlStyle.overflow = 'hidden';
    bodyStyle.overflow = 'hidden';
    bodyStyle.position = 'fixed';
    bodyStyle.top = `-${scrollY}px`;
    bodyStyle.width = '100%';
  };

  unlockBodyScroll() {
    if (!this._bodyScrollLockState) return;

    const {
      scrollY,
      bodyOverflow,
      bodyPosition,
      bodyTop,
      bodyWidth,
      htmlOverflow,
    } = this._bodyScrollLockState;

    document.documentElement.style.overflow = htmlOverflow || '';
    document.body.style.overflow = bodyOverflow || '';
    document.body.style.position = bodyPosition || '';
    document.body.style.top = bodyTop || '';
    document.body.style.width = bodyWidth || '';
    this._bodyScrollLockState = null;

    window.scrollTo(0, scrollY);
  };

  logTimeoutError(errDetails) {
    const now = Date.now();
    if (now - this._lastTimeoutErrorTs > 5000) {
      this._lastTimeoutErrorTs = now;
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
        [["Content-Type", "application/json"]],
        errDetails,
        function(data){},
        function(err){},
      );
    }
  };

  handleCreateTimeoutFallback(errDetails) {
    this.logTimeoutError(errDetails);
    this.CHECKOUT_ERROR = true;
    this.ERROR_OCCURRED = true;
    this.triggerShopifyCheckout(document.getElementById('buyNow1CheckoutBtn'));
  };

  isSeriousCreateError(err, status) {
    const statusCode = Number(status) || 0;
    const msg = (err && (err.message || err.error || err.detail) ? String(err.message || err.error || err.detail) : '').toLowerCase();

    // Only hard-fallback for clearly terminal scenarios.
    if ([401, 403, 404].includes(statusCode)) return true;
    if (msg.includes('merchant not active')) return true;
    if (msg.includes('invalid api key')) return true;
    if (msg.includes('unauthorized')) return true;
    return false;
  };

  //--- Overriding buy now button
  addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData) {
    var item = items.pop();
    if (item) {
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', '/cart/add.js',
        [['Content-type', 'application/json; charset=UTF-8']],
        {
          'items': [item]
        },
        function(data) {
        },
        function(err) {
          const message = oneCheckout.getCustomerEventErrorMessage(
            err,
            'An item could not be added to cart.'
          );
          unaddedItems.push(message);
        },
        function() {
          oneCheckout.addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData); 
        });
    } else {
      if (unaddedItems.length > 0) {
        let unaddedItemsHtml = '';
        unaddedItems.forEach(item => {
          unaddedItemsHtml += `<li style="text-align: left;">${item}</li>`;
        });
        var title = '<h3 style="text-align: center; color: #404143;">Oops!</h3>';
        var message = `<div style="text-align: center; color: #404143;"><ul style="max-height: 118px;overflow-y: auto;">${unaddedItemsHtml}</ul></div>`;
        var goHomeLink = `<a href="/cart" style="margin-top: 16px;background-color: #404143;color: #fff;padding: 8px 46px;border-radius: 4px;text-decoration: none;">Ok</a>`;
        var style = 'position: absolute; display: flex; flex-direction: column; align-items: center;';
        style += 'width: 350px; left: calc(50% - 175px); top: 30%;';
        style += 'background-color: #fff; border-radius: 4px; padding: 16px;';
        var showError = `<div style="${style}">${title}${message}${goHomeLink}</div>`;
        document.getElementById('checkoutRedirectOverlay').innerHTML = showError;
      } else {
        if (this.TRIGGER_1CHECKOUT) {
          var _data = {showError: false};
          document.getElementById('checkoutRedirectOverlay').remove();
          document.querySelector('.checkout-progressbar').classList.remove('dc-none');
          this.startProgressBarAnimation();
          this.startLoaderMessages();
          // try {
          //   _data["phone"] = checkoutData.user_phone_number;
          // } catch (err) {}
          _data["checkout_type"] = "checkout";
          document.getElementById('checkoutModal').checked = true;
          this.initCheckoutIframe(_data);
          // const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
          // iframe.onload = function(){
          //   iframe.contentWindow.postMessage({checkout_id: checkoutData.checkout_id, checkout_url: checkoutData.checkout_url, topic: '1CHECKOUTDATA'}, '*');
          //   oneCheckout.checkoutLoaded();
          // }
        } else if (this.REFRESH_CART) {
          window.location.replace('/cart');
        };
      };
    };
  };

  // Trigger WA 1Commerce flow
  triggerWA1CheckoutOnPageLoad() {
    if (['/cart', '/cart/'].includes(window.location.pathname) && this.REFRESH_CART) {
      this.CHECKOUT_ID = ONE_CHECKOUT_UTIL.URL_PARAMS.get('cid');
      if (this.CHECKOUT_ID) {
        // Fetch the checkout info from server
        ONE_CHECKOUT_UTIL.apiRequest(
          'GET', `${API_HOST_1C}/checkouts/${this.CHECKOUT_ID}`,
          this.API_HEADERS,
          {},
          function(checkoutData) {
            oneCheckout.CHECKOUT_URL = checkoutData.checkout_url;
            // Clear the cart
            // oneCheckout.initCheckoutIframe({showError: false, checkout_type: "checkout", phone: checkoutData.user_phone_number});
            // const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
            // if (iframe) {
            //   iframe.onload = function(){
            //     iframe.contentWindow.postMessage({checkout_id: checkoutData.checkout_id, checkout_url: checkoutData.checkout_url, topic: '1CHECKOUTDATA'}, '*');
            //     oneCheckout.checkoutLoaded();
            //   }
            // }
            ONE_CHECKOUT_UTIL.apiRequest(
              'GET', '/cart/clear.js',
              [['Content-type', 'application/json; charset=UTF-8']],
              {},
              function(data) {
                var items = [];
                checkoutData.cart.items.forEach(item => {
                  var itemProperties = {};

                  if (Array.isArray(item.properties)) {
                    item.properties.forEach(property => {
                      if (!property || !property.name) return;
                      itemProperties[property.name] = property.value;
                    });
                  } else if (item.properties && typeof item.properties === 'object') {
                    itemProperties = item.properties;
                  }

                  var itemPayload = {
                    'id': item.variant_id,
                    'quantity': item.quantity,
                    'product-id': item.product_id,
                    'properties': itemProperties,
                  };

                  items.push(itemPayload);
                });
                var unaddedItems = [];
                oneCheckout.addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData);
              },
              function(err) {
              },
              function() {
              });
          },
          function(err) {
            console.log(err);  // TODO
          });
      };
    };
  };

  // Toggle enable/disable 1Checkout btn when a separate variant is selected
  checkVariantAvailability(variantId) {
    try {
      var productHandle = document.getElementById('productHandle1Checkout').value;
      if (productHandle) {
        ONE_CHECKOUT_UTIL.apiRequest(
          'GET', `/products/${productHandle}.js`,
          [['Content-type', 'application/json; charset=UTF-8']],
          {},
          function(data) {
            var variantAvailable = true;
            data.variants.forEach(variant => {
              if (variant.id == variantId) {
                variantAvailable = variant.available;
              };
            });
            if (!variantAvailable) {
              document.getElementById('buyNow1CheckoutBtn').disabled = true;
            } else {
              document.getElementById('buyNow1CheckoutBtn').disabled = false; 
            };
          },
          function(err) {
          });
      } else {
        document.getElementById('buyNow1CheckoutBtn').disabled = false;
      };
      document.getElementById('buyNow1CheckoutError').classList.add('dc-none');
    } catch (err) {}
  };

  checkoutModalToggled(el) {
    if (el.checked == true){
      document.querySelector('.checkout-progressbar').classList.remove('dc-none');
      this.startProgressBarAnimation();
      this.startLoaderMessages();
      this.lockBodyScroll();
      // this.startAnimation();
      this.initialize1Checkout();
    } else {
      this.unlockBodyScroll();
    };
  };
  
  triggerShopifyCheckout(el){
    const resetTriggerBtn = () => {
      if (!el) return;
      try {
        el.disabled = false;
        el.querySelector('.btn-1checkout-title')?.classList.remove('dc-none');
        el.querySelector('.btn-1checkout-spinner')?.classList.add('dc-none');
      } catch (err) {}
    };

    ONE_CHECKOUT_UTIL.apiRequest(
      'GET', '/cart.json',
      [['Content-type', 'application/json']],
      {},
      function(cartJson) {
        window.location.href= `${window.location.origin}/checkout`;
        setTimeout(()=>{
          resetTriggerBtn();
          oneCheckout.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
        }, 3000);
      },
      function(err) {
        resetTriggerBtn();
        // Never keep the user in limbo on fallback flow failures.
        window.location.href= `${window.location.origin}/checkout`;
        setTimeout(()=>{
          oneCheckout.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
        }, 3000);
      }
    );
    if (el) {
      el.disabled = true;
      el.querySelector('.btn-1checkout-title')?.classList.add('dc-none');
      // el.querySelector('.btn-1checkout-sub-title').classList.add('dc-none');
      el.querySelector('.btn-1checkout-spinner')?.classList.remove('dc-none');
    }
  }

  trigger1Checkout(el) {
    var giftCardElement = document.getElementById('1cGiftCard');
    if((giftCardElement && giftCardElement !== null && giftCardElement.checked)){
      this.triggerShopifyCheckout(el);
    }else if(this.CHECKOUT_ERROR){
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
        [{"Content-Type": "application/json"}],
        {"location": window.location.href, "error": "Merchant not active"},
        function(data){},
        function(err){},
      );
      this.triggerShopifyCheckout(el);
    }else{
      var initCheckbox = document.getElementById('checkoutModal');
      initCheckbox.checked = true;
      this.checkoutModalToggled(initCheckbox);
    }
  };
  
  // buyNow1CheckoutBtn click
  buyNow1Checkout(el) {
    document.getElementById('buyNow1CheckoutError').classList.add('dc-none');
    el.disabled = true;
    try {
      el.setAttribute("disabled", true);
    } catch(err) {
      // console.log(err);
    }
    el.querySelector('.btn-1checkout-title').classList.add('dc-none');
    // el.querySelector('.btn-1checkout-sub-title').classList.add('dc-none');
    el.querySelector('.btn-1checkout-spinner').classList.remove('dc-none');
  
    try {
      var variantId = el.closest('form').querySelector('[name="id"]').value;
    } catch (error) {
      var variantId = document.querySelector('[name="id"]').value;
    };
    try {
      try {
        var quantity = el.closest('form').querySelector('[name="quantity"]').value;
      } catch (error) {
        var quantity = document.querySelector('[name="quantity"]').value;
      };
    } catch (error) {
      var quantity = 1;
    };
    
    var properties = {};
    document.querySelectorAll('[name*="properties["]').forEach(el => {
      var propKey = el.getAttribute('name');
      propKey = propKey.match(/\[(.*)\]/i);
      if (propKey.length > 1) {
        properties[propKey[1]] = el.value;
      };
    });

    ONE_CHECKOUT_UTIL.apiRequest(
      'GET', '/cart/clear.js',
      [['Content-type', 'application/json; charset=UTF-8']],
      {},
      function(data) {
        ONE_CHECKOUT_UTIL.apiRequest(
          'POST', '/cart/add.js',
          [['Content-type', 'application/json; charset=UTF-8']],
          {
            'items': [
              {
                'id': variantId,
                'quantity': quantity,
                'properties': properties
              }
            ]
          },
          function(data) {
            if(oneCheckout.CHECKOUT_ERROR){
              ONE_CHECKOUT_UTIL.apiRequest(
                'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                [{"Content-Type": "application/json"}],
                {"location": window.location.href, "error": "Merchant not active"},
                function(data){},
                function(err){},
              );
              oneCheckout.triggerShopifyCheckout(el);
            } else {
              // Trigger 1checkout modal
              document.getElementById('checkoutModal').click();
              // Trigger cart update JS event
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variantId,
                  quantity: quantity
                }
              }));
            }
          },
          function(err) {
            const errorMessage = oneCheckout.getCustomerEventErrorMessage(
              err,
              'Unable to add this product to cart right now.'
            );
            document.getElementById('buyNow1CheckoutError').innerHTML = errorMessage;
            document.getElementById('buyNow1CheckoutError').classList.remove('dc-none');
          });
      },
      function(err) {
      },
      function() {
        if(!oneCheckout.CHECKOUT_ERROR){
          setTimeout(()=>{
            el.querySelector('.btn-1checkout-title').classList.remove('dc-none');
            // el.querySelector('.btn-1checkout-sub-title').classList.remove('dc-none');
            el.querySelector('.btn-1checkout-spinner').classList.add('dc-none');
            el.disabled = false;
          }, [2000]);
        }
      });
  };
  
  // Initializing 1Checkout popup
  initialize1Checkout() {
    this.resetShopifyCustomerEventState();

    if (IS_DEMO_1C_PAGE) {
      this.CHECKOUT_CART = {...this.CHECKOUT_CART, ...fakeCart};
      // Create a fake checkout object
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', `${API_HOST_1C}/create`,
        this.API_HEADERS,
        this.CHECKOUT_CART,
        function(data) {
          oneCheckout.ERROR_OCCURRED = false;
          oneCheckout.CHECKOUT_ID = data.checkout_id;
          oneCheckout.CHECKOUT_URL = data.checkout_url;
          oneCheckout.updateShopifyCustomerEventState({
            checkoutId: data.checkout_id,
            checkoutUrl: data.checkout_url,
          });
          oneCheckout.initCheckoutIframe({ showError: false, checkout_type: "checkout" });
        },
        function(err) {
          // console.log(err);
          if (err && err.message === 'timeout') {
            const errDetails = {
              "location": window.location.href,
              "error": "Timeout error of more than 10 seconds",
              ...oneCheckout.CHECKOUT_CART
            };
            oneCheckout.handleCreateTimeoutFallback(errDetails);
          } else {
            oneCheckout.initCheckoutIframe({showError: true, checkout_type: "checkout"});
            oneCheckout.ERROR_OCCURRED = true;
          }
        }, null, 5000, 1);
    } else {
      // Get the cart json
      ONE_CHECKOUT_UTIL.apiRequest(
        'GET', '/cart.json',
        [['Content-type', 'application/json']],
        {},
        function(cartJson) {
          if(cartJson.item_count > 0 && cartJson.items.length > 0){
            const districtInput = document.getElementById("district");
            const clubNameInput = document.getElementById("club-name");
            const originalShopifyCartToken = cartJson.token || cartJson.cart_token || null;
            function appendRandomToToken(token) {
              const randomNumber = Math.floor(Math.random() * 1e6); // Generates a number between 0 and 999999
              return `${randomNumber}-${token}`;
            }
            
            if (cartJson.token) {
              cartJson.token = appendRandomToToken(cartJson.token);
            }

            if (districtInput) {
              oneCheckout.CHECKOUT_CART = { ...oneCheckout.CHECKOUT_CART, "district": districtInput.value };
            }

            if (clubNameInput) {
              oneCheckout.CHECKOUT_CART = { ...oneCheckout.CHECKOUT_CART, "club_name": clubNameInput.value };
            }
            oneCheckout.CHECKOUT_CART = {...oneCheckout.CHECKOUT_CART, ...cartJson};
            Object.keys(oneCheckout.QUERY_PARAMS_1C).forEach((key) => {
              const value = oneCheckout.QUERY_PARAMS_1C[key];
              if(value !== null){
                oneCheckout.CHECKOUT_CART[key] = value;
              }
            });
            oneCheckout.setShopifyCartContext(
              oneCheckout.CHECKOUT_CART,
              originalShopifyCartToken
            );
            // Create checkout object
            ONE_CHECKOUT_UTIL.apiRequest(
              'POST', `${API_HOST_1C}/create`,
              oneCheckout.API_HEADERS,
              oneCheckout.CHECKOUT_CART,
              function(data) {
                oneCheckout.ERROR_OCCURRED = false;
                oneCheckout.CHECKOUT_ID = data.checkout_id;
                oneCheckout.CHECKOUT_URL = data.checkout_url;
                oneCheckout.updateShopifyCustomerEventState({
                  checkoutId: data.checkout_id,
                  checkoutUrl: data.checkout_url,
                });
                oneCheckout.initCheckoutIframe({ showError: false, checkout_type: "checkout" });
              },
              function(err, status) {
                if (err && err.message === 'timeout') {
                  const errDetails = {
                    "location": window.location.href,
                    "error": "Timeout error of more than 10 seconds",
                    ...oneCheckout.CHECKOUT_CART
                  };
                  oneCheckout.handleCreateTimeoutFallback(errDetails);
                } else {
                  const headers = oneCheckout.API_HEADERS.reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                  }, {});
                  const errDetails = {
                    "location": window.location.href,
                    "error": "Create api error",
                    ...err,
                    ...oneCheckout.CHECKOUT_CART,
                    ...headers,
                    status
                  };
                  ONE_CHECKOUT_UTIL.apiRequest(
                    'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                    [{"Content-Type": "application/json"}],
                    errDetails,
                    function(data){},
                    function(err){},
                  );
                  if(oneCheckout.isSeriousCreateError(err, status)){
                    oneCheckout.ERROR_OCCURRED = true;
                    setTimeout(()=>{
                      window.location.href= `${window.location.origin}/checkout`;
                      oneCheckout.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
                    }, 500);
                  } else {
                    const errorMessage = err && err.message ? err.message : 'Temporary issue. Please retry.';
                    oneCheckout.ERROR_OCCURRED = true;
                    oneCheckout.initCheckoutIframe({showError: true, checkout_type: "checkout", error_msg: errorMessage});
                  }
                }
              }, null, 5000, 1);
          } else {
            // try {
            //   const headers = oneCheckout.API_HEADERS.reduce((acc, [key, value]) => {
            //     acc[key] = value;
            //     return acc;
            //   }, {});
            //   const errDetails = {
            //     "location": window.location.href,
            //     "error": "Create api not called as no cartItems found",
            //     ...cartJson,
            //     ...headers,
            //   }
            //   ONE_CHECKOUT_UTIL.apiRequest(
            //     'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
            //     [{"Content-Type": "application/json"}],
            //     errDetails,
            //     function(data){},
            //     function(err){},
            //   );
            // } catch(err) {
            //   const errDetails = {
            //     "location": window.location.href,
            //     "error": "Create api not called as no cartItems found",
            //   }
            //   ONE_CHECKOUT_UTIL.apiRequest(
            //     'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
            //     [{"Content-Type": "application/json"}],
            //     errDetails,
            //     function(data){},
            //     function(err){},
            //   );
            // }
            oneCheckout.ERROR_OCCURRED = true;
            oneCheckout.initCheckoutIframe({showError: false, cartError: true, checkout_type: "checkout"});
          }
        },
        function(err) {
          // console.log(err);
          oneCheckout.ERROR_OCCURRED = true;
          oneCheckout.initCheckoutIframe({showError: true, checkout_type: "checkout"});
        });
    };
  };
  
  initCheckoutIframe(params) {
    if (this.ERROR_OCCURRED && params.showError === false) {
      delete params.showError;
    }

    if (this.ERROR_OCCURRED) {
      params.showError = true;
    }

    if (params.showError === true || params.cartError === true) {
      this.ERROR_OCCURRED = true;
    }


    params['containerheight'] = (document.querySelector('.checkoutmodal .inner').offsetHeight) || 720;
    // params['checkoutid'] = this.CHECKOUT_ID;
    // params['checkouturl'] = this.CHECKOUT_URL;
    params['apikey'] = API_KEY_1C;
    params['discount'] = ONE_CHECKOUT_UTIL.URL_PARAMS.get('discount');
  
    var iframeUrl = new URL(`${HOST_1C}/v4/checkout/widget/`);
    Object.keys(params).forEach(key => {
      if (params[key] !== null) {
        iframeUrl.searchParams.set(key.toLowerCase(), params[key]);
      };
    });
  
    // Populate IP address
    if (this.CHECKOUT_CLIENT_IP_ADDRESS) {
      iframeUrl.searchParams.set('ip', this.CHECKOUT_CLIENT_IP_ADDRESS);
    };

    // Populate all query params
    Object.keys(this.QUERY_PARAMS_1C).forEach(key => {
      iframeUrl.searchParams.set(key, this.QUERY_PARAMS_1C[key]);
    });

    // Populate fb pixel from cookie. Must come after QUERY_PARAMS_1C: those
    // carry the raw landing-page fbclid, which would otherwise overwrite the
    // full fb.1.<ts>.<id> _fbc value (seeded or set by Meta's pixel).
    var fbclid = ONE_CHECKOUT_UTIL.get1CheckoutCookie('_fbc');
    if (fbclid) {
      iframeUrl.searchParams.set('fbclid', fbclid);
    };

    // Populate fb pixel from cookie
    var fbp = ONE_CHECKOUT_UTIL.get1CheckoutCookie('_fbp');
    if (fbp) {
      iframeUrl.searchParams.set('fbp', fbp);
    };

    // Populate ga token from cookie
    var ga = ONE_CHECKOUT_UTIL.get1CheckoutCookie('_ga');
    if (ga) {
      iframeUrl.searchParams.set('ga', ga);
    };

    var trackier_clid = ONE_CHECKOUT_UTIL.get1CheckoutCookie('__tr_clid');
    if(trackier_clid) {
      iframeUrl.searchParams.set('__tr_clid', trackier_clid);
    }
  
    // Populate the page url
    iframeUrl.searchParams.set('url', encodeURI(window.location.href));

    const existingIframe = document.querySelector('.checkoutmodal .iframe-container iframe');
    if (existingIframe) {
      existingIframe.classList.add('dc-none');
      this.startIframeLoadWatchdog();
      existingIframe.onload = function(){
        oneCheckout.checkoutLoaded();
      };
      existingIframe.onerror = function(){
        oneCheckout.clearIframeLoadWatchdog();
        oneCheckout.showCheckoutRetryMessage('Checkout could not load.');
      };
      existingIframe.src = iframeUrl.href;
      return;
    }

    // const scriptElement = document.querySelector('script[src*="https://svc.nitrocommerce.ai/"]');

    // function callNitroApi(token, parent_id, nitro_id){
    //   ONE_CHECKOUT_UTIL.apiRequest(
    //     'POST', `${API_HOST_1C}/ntro/find`,
    //     oneCheckout.API_HEADERS,
    //     {
    //       token,
    //       parent_id,
    //       nitro_id,
    //     },
    //     function(data) {
    //       if(data?.data?.phone !== null){
    //         iframeUrl.searchParams.set('nitro_phone', data?.data?.phone);
    //       }
    //       if (params['checkout_type'] == "checkout") {
    //         const iframeDiv = document.querySelector('.checkoutmodal .iframe-container iframe');
    //         if(!iframeDiv) {
    //           document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" allow="otp-credentials; web-share; clipboard-write" referrerpolicy="origin" loading="eager" class="dc-none"></iframe>`;
    //         }
    //       }
    //     },
    //     function(err){
    //       console.log(err);
    //       if (params['checkout_type'] == "checkout") {
    //         const iframeDiv = document.querySelector('.checkoutmodal .iframe-container iframe');
    //         if(!iframeDiv) {
    //           document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" allow="otp-credentials; web-share; clipboard-write" referrerpolicy="origin" loading="eager" class="dc-none"></iframe>`;
    //         }
    //       }
    //     }
    //   );
    // }

    // let retryCount = 0; // Initialize a counter

    // // Function to call nitro.ready
    // function callNitroReady() {
    //     if (typeof nitro !== 'undefined' && typeof nitro.ready === 'function') {
    //       nitro.ready(function(token, parent, nitro_id) {
    //         if(token !== null && parent !== null && nitro_id !== null){
    //           callNitroApi(token, parent, nitro_id);
    //         } else if (retryCount < 15) {
    //           retryCount++;
    //           setTimeout(callNitroReady, 200); // Retry after 200ms
    //         } else {
    //           // console.log("Maximum retry attempts reached after nitro found. Executing fallback action...");
    //           const iframeDiv = document.querySelector('.checkoutmodal .iframe-container iframe');
    //           if(!iframeDiv) {
    //             document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" allow="otp-credentials; web-share; clipboard-write" referrerpolicy="origin" loading="eager" class="dc-none"></iframe>`;
    //           }
    //         }
    //       });
    //     } else if (retryCount < 15) {
    //       retryCount++;
    //       // console.log("nitro.ready is not available yet, retrying...");
    //       setTimeout(callNitroReady, 200); // Retry after 200ms
    //     } else {
    //       // console.log("Maximum retry attempts reached. Executing fallback action...");
    //       const iframeDiv = document.querySelector('.checkoutmodal .iframe-container iframe')
    //       if(!iframeDiv) {
    //         document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" allow="otp-credentials; web-share; clipboard-write" referrerpolicy="origin" loading="eager" class="dc-none"></iframe>`;
    //       }
    //     }
    // }

    // if (scriptElement) {
    //   if (scriptElement.onload) {
    //     setTimeout(callNitroReady, 500);
    //   } else {
    //     scriptElement.onload = function() {
    //       setTimeout(callNitroReady, 500);
    //     };
    //   }
    // } else {
    //   // console.log('Script element not found.');
    //   if (params['checkout_type'] == "checkout") {
    //     const iframeDiv = document.querySelector('.checkoutmodal .iframe-container iframe')
    //     if(!iframeDiv){
    //       document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" allow="otp-credentials; web-share; clipboard-write" referrerpolicy="origin" loading="eager" class="dc-none"></iframe>`;
    //     }
    //   }
    // }
    if (params['checkout_type'] == "checkout") {
      const iframeDiv = document.querySelector('.checkoutmodal .iframe-container iframe');
      if(!iframeDiv){
        this.startIframeLoadWatchdog();
        document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" onerror="oneCheckout.clearIframeLoadWatchdog(); oneCheckout.showCheckoutRetryMessage('Checkout could not load.')" name="oneCheckoutIframe" loading="eager" class="dc-none"></iframe>`;
      }
    }
  };
  
  exitLoaderAnimation(){
    const animatedDiv = document.querySelector('.checkoutmodal .splash-screen');
    const animatedText = document.querySelector('.checkout-progressbar p');

    animatedText.style.color = '#fff';

    animatedDiv.animate([ { opacity: 1 }, { opacity: 0 }], { duration: 700 });

    // setTimeout(()=>{
      document.querySelector('.checkoutmodal .splash-screen').classList.add('dc-none');
    // }, 700)
  }

  checkoutLoaded() {
    this.clearIframeLoadWatchdog();
    var iframe = document.querySelector('.checkoutmodal iframe');
    if (!iframe) return;
    iframe.classList.remove('dc-none');

    // this.exitLoaderAnimation();
    document.querySelector('.checkoutmodal .splash-screen').classList.add('dc-none');
    this.resetSplashScreen();

    if(this.CHECKOUT_ID && this.CHECKOUT_URL){
      const message = {
        checkout_id: this.CHECKOUT_ID,
        checkout_url: this.CHECKOUT_URL,
        token: oneCheckout.CHECKOUT_CART.token,
        shopify_cart_token: oneCheckout.SHOPIFY_CUSTOMER_EVENTS.cartToken,
        topic: '1CHECKOUTDATA'
      };

      const sendMessage = () => {
        const activeIframe =
          document.querySelector('.checkoutmodal iframe[name="oneCheckoutIframe"]') ||
          document.querySelector('.checkoutmodal .iframe-container iframe');
        if (!activeIframe || !activeIframe.contentWindow) return;

        try {
          activeIframe.contentWindow.postMessage(message, '*');
        } catch (err) {
          const errDetails = {
            "location": window.location.href,
            "error": "Error posting message to iframe",
            message: err.message,
            ...oneCheckout.CHECKOUT_CART
          };
          ONE_CHECKOUT_UTIL.apiRequest(
            'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
            [["Content-Type", "application/json"]],
            errDetails,
            function(data){},
            function(err){}
          );
        }
      };

      sendMessage();
      setTimeout(sendMessage, 100);

      // Trigger fb pixel event
      // try {
      //   fbq('track', 'InitiateCheckout', {
      //     content_type: 'product_group',
      //     content_ids: this.CHECKOUT_CART.getCartProductIds(),
      //     value: parseFloat((this.CHECKOUT_CART.total_price / 100).toFixed(2)),
      //     contents: this.CHECKOUT_CART.getCartItemDetails(),
      //     num_items: this.CHECKOUT_CART.getCartItemCount(),
      //     currency: this.CHECKOUT_CART.currency,
      //     event_id: `1C_InitiateCheckout_${this.CHECKOUT_ID}`,
      //   },
      //   { eventID: `1C_InitiateCheckout_${this.CHECKOUT_ID}` }
      // );
      // } catch (e) {
      //   console.warn('fbq error for "InitiateCheckout"', e);
      // };

      // Trigger ga event
      try {
        ga('send', {
          hitType: 'event',
          eventCategory: 'ecommerce',
          eventAction: 'begin_checkout',
          eventLabel: '1checkout'});
      } catch (e) {
        console.warn('ga error for "InitiateCheckout"', e);
      };
    }
  };

  // Function to start the animation
  startAnimation() {
    const animatedDiv = document.querySelector('.bounce-loader');

    // Reset the animation
    animatedDiv.style.animation = 'none';
    animatedDiv.offsetHeight; // Trigger a reflow, resetting the animation
    animatedDiv.style.animation = 'bounce-anim 3s forwards 100ms'; // Start the bounce animation
  }

  messageListener(event) {
    function mapItems(items){
      return items.map(it => ({
        item_id    : it.sku,         // SKU or variant ID
        item_name  : it.name,        // Product name
        price      : it.price,       // Unit price (number, not string)
        quantity   : it.quantity
      }));
    }

    let gclid = (new URLSearchParams(location.search)).get('gclid');

    if(!gclid){
      let localParams = ONE_CHECKOUT_UTIL.get1CheckoutLocalStorage('queryparams_1c');

      try{
        if (typeof localParams === 'string') {
          localParams = JSON.parse(localParams);
        }

        if (localParams && typeof localParams === 'object') {
          gclid = localParams.gclid || null;
        }
      } catch (e) {
        console.error("Failed to parse queryparams_1c from local storage", e);
      }
    }

    if (event.origin == HOST_1C) {
      if (event.data.topic == '1CHECKOUT') {
        const customerEventFragment =
          event.data.event_payload &&
          typeof event.data.event_payload === 'object'
            ? event.data.event_payload
            : {};

        if (event.data.message == 'launch_truecaller') {
          document.location = event.data.truecallerDeeplink;
        } else if (event.data.message == 'exit_checkout') {
          oneCheckout.ERROR_OCCURRED = false;
          document.querySelector('.checkoutmodal .overlay').classList.add('dc-none');
          document.querySelector('.checkoutmodal .splash-screen').classList.remove('dc-none');
          const modalToggle = document.getElementById('checkoutModal');
          if (modalToggle) {
            modalToggle.checked = false;
            oneCheckout.checkoutModalToggled(modalToggle);
          }
          document.querySelector('.checkoutmodal iframe[name="oneCheckoutIframe"]')?.remove();

          // this.initCheckoutIframe({showError: false, checkout_type: "checkout"});
          
          // if (event.data.fallback) {
          //   // Disable 1C for 4 hours
          //   ONE_CHECKOUT_UTIL.set1CheckoutLocalStorage('d1c', true, 4);
          // };
          if (event.data.nextPage) {
            window.location.replace(event.data.nextPage);
          };
          // If 1checkout was loaded from WA commerce, refresh on exit to refresh the cart UI
          this.CHECKOUT_ID = ONE_CHECKOUT_UTIL.URL_PARAMS.get('cid');
          
          if (this.CHECKOUT_ID && this.TRIGGER_1CHECKOUT) {
            window.location.replace(`/cart?cid=${this.CHECKOUT_ID}&t1c=false&refresh=false`);
          };
        } else if (event.data.message == 'clear_cart') {
          ONE_CHECKOUT_UTIL.apiRequest(
            'POST', '/cart/clear.js',
            [['Content-type', 'application/json; charset=UTF-8']],
            {},
            function(data) {
            },
            function(err) {
            });
        } else if (event.data.message == 'launch_upi_app') {
          document.location = event.data.deeplink;
        } else if (event.data.message == "iframe_launched") {
          this.publishShopifyCustomerEvent('checkout_started', {
            checkoutId: event.data.checkoutId || this.CHECKOUT_ID,
            checkoutUrl: event.data.checkout_url || this.CHECKOUT_URL,
            totalPrice: event.data.totalCartValue,
            currency: event.data.currency || this.SHOPIFY_CUSTOMER_EVENTS.currency,
            couponCode: event.data.couponCode || this.SHOPIFY_CUSTOMER_EVENTS.couponCode,
            totalDiscountApplied:
              event.data.totalDiscount !== undefined
                ? event.data.totalDiscount
                : this.SHOPIFY_CUSTOMER_EVENTS.totalDiscountApplied,
            shippingMethod:
              event.data.shippingMethod || this.SHOPIFY_CUSTOMER_EVENTS.shippingMethod,
          });
          if(event.data.fb_ids && event.data.fb_ids!== null && event.data.fb_ids.length > 0) {
            try {
              fbq('track', 'InitiateCheckout', {
                content_type: 'product_group',
                content_ids: event.data.cartProductIds,
                value: event.data.totalCartValue,
                contents: event.data.cartItemDetails,
                num_items: event.data.cartItemCount,
                currency: event.data.currency,
                event_id: event.data.event_id,
              },
              { eventID: event.data.event_id }
            );
            } catch (e) {
              console.warn('fbq error for "InitiateCheckout"', e);
            };
          }
          if(event.data.ga_ids && event.data.ga_ids!== null && event.data.ga_ids.length > 0) {
            try {
              gtag('event', 'begin_checkout', {
                transaction_id : `1C_begin_checkout_${event.data.checkoutId}`,          // de-dupe key
                value          : event.data.totalCartValue,   // **gross** order value
                currency       : 'INR',
                tax            : event.data.totalTax,
                shipping       : event.data.shippingCharges,
                coupon         : event.data.couponCode || undefined,
                items          : mapItems(event.data.cartItemDetails),
                gclid          : gclid                // include if present
              });
            } catch(e) {
              console.log(e, "gtag begin checkout error");
            }
          }
        } else if (event.data.message == 'mobile_added') {
          this.publishShopifyCustomerEvent('mobile_added', customerEventFragment);
        } else if (event.data.message == 'address_step_reached') {
          this.publishShopifyCustomerEvent(
            'address_step_reached',
            customerEventFragment
          );
        } else if (event.data.message == 'address_added') {
          this.publishShopifyCustomerEvent('address_added', customerEventFragment);
        } else if (event.data.message == 'payment_step_reached') {
          this.publishShopifyCustomerEvent(
            'payment_step_reached',
            customerEventFragment
          );
        } else if(event.data.message == 'remove_ac_coupon'){
          deleteLocalStorage('coupon_code');
        } else if(event.data.message == 'gift_card_redirect') {
          window.location.href = event.data.url;
          setTimeout(()=>{
            this.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
          }, 1000);
        } else if (event.data.message == 'otp_verified') {
          try {
            fbq('track', 'CompleteRegistration', {
              content_type: 'product_group',
              content_ids: event.data.cartProductIds,
              value: event.data.totalCartValue,
              contents: event.data.cartItemDetails,
              num_items: event.data.cartItemCount,
              currency: event.data.currency,
              event_id: event.data.event_id,
            },
            { eventID: event.data.event_id }
          );
          } catch (e) {
            console.warn('fbq error for "CompleteRegistration"', e);
          };
        } else if (event.data.message == 'payment_initiated') {
          if(event.data.fb_ids && event.data.fb_ids!== null && event.data.fb_ids.length > 0) {
            try {
              fbq('track', 'AddPaymentInfo', {
                content_type: 'product_group',
                content_ids: event.data.cartProductIds,
                value: event.data.totalCartValue,
                contents: event.data.cartItemDetails,
                num_items: event.data.cartItemCount,
                currency: event.data.currency,
                event_id: event.data.event_id,
              },
              { eventID: event.data.event_id }
            );
            } catch (e) {
              console.warn('fbq error for "AddPaymentInfo"', e);
            };
          }

          if(event.data.ga_ids && event.data.ga_ids!== null && event.data.ga_ids.length > 0) {
            try {
              gtag('event', 'add_payment_info', {
                transaction_id : `1C_add_payment_info_${event.data.checkoutId}`,          // de-dupe key
                value          : event.data.totalCartValue,   // **gross** order value
                currency       : 'INR',
                tax            : event.data.totalTax,
                shipping       : event.data.shippingCharges,
                coupon         : event.data.couponCode || undefined,
                items          : mapItems(event.data.cartItemDetails),
                gclid          : gclid                // include if present
              });
            } catch(e) {
              console.log(e, "gtag add payment info error");
            }
          }
        } else if (event.data.message == 'order_placed') {
          this.publishShopifyCustomerEvent('order_purchased', {
            checkoutId: event.data.checkoutId || this.CHECKOUT_ID,
            checkoutUrl:
              event.data.checkout_url ||
              this.CHECKOUT_URL ||
              this.SHOPIFY_CUSTOMER_EVENTS.checkoutUrl,
            totalPrice:
              event.data.totalCartValue !== undefined
                ? event.data.totalCartValue
                : this.SHOPIFY_CUSTOMER_EVENTS.totalPrice,
            currency: event.data.currency || this.SHOPIFY_CUSTOMER_EVENTS.currency,
            couponCode:
              event.data.couponCode || this.SHOPIFY_CUSTOMER_EVENTS.couponCode,
            totalDiscountApplied:
              event.data.totalDiscount !== undefined
                ? event.data.totalDiscount
                : this.SHOPIFY_CUSTOMER_EVENTS.totalDiscountApplied,
            shippingMethod:
              event.data.shippingMethod || this.SHOPIFY_CUSTOMER_EVENTS.shippingMethod,
            orderId: event.data.orderId || this.SHOPIFY_CUSTOMER_EVENTS.orderId,
          });

          if(event.data.fb_ids && event.data.fb_ids!== null && event.data.fb_ids.length > 0) {
            try {
              fbq('track', 'Purchase', { 
                content_type: 'product_group',
                content_ids: event.data.cartProductIds,
                value: event.data.totalCartValue,
                contents: event.data.cartItemDetails,
                num_items: event.data.cartItemCount,
                currency: event.data.currency,
                event_id: event.data.event_id,
              }, 
              { eventID: event.data.event_id }
            );
            } catch (e) {
              console.warn('fbq error for "Purchase"', e);
            };
          }

          if(event.data.ga_ids && event.data.ga_ids!== null && event.data.ga_ids.length > 0) {
            try {
              gtag('event', 'purchase', {
                transaction_id : `1C_purchase_${event.data.checkoutId}`,          // de-dupe key
                value          : event.data.totalCartValue,   // **gross** order value
                currency       : 'INR',
                tax            : event.data.totalTax,
                shipping       : event.data.shippingCharges,
                coupon         : event.data.couponCode || undefined,
                items          : mapItems(event.data.cartItemDetails),
                gclid          : gclid                // include if present
              });
            } catch(e) {
              console.log(e, "gtag purchase error");
            }
          }
        } else if (event.data.message == 'checkout_conversion') {
          // Delete UTM params and send fbq and ga
          try{
            // console.log("Successful conversion");
            gtag('event', 'conversion', {
              'send_to': event.data.send_to_key,
              'value': event.data.totalCartValue,
              'currency': 'INR',
              'transaction_id': event.data.transaction_id,
            });
          }catch(err){
            // console.log(err, "Error in google ads conversion")
          }
          // try {
          //   ga('send', {
          //     hitType: 'event',
          //     eventCategory: 'ecommerce',
          //     eventAction: 'purchase',
          //     eventLabel: '1checkout',
          //     eventValue: event.data.totalCartValue});
          //   ga('require', 'ecommerce');
          //   ga('ecommerce:addTransaction', {
          //     'id': event.data.orderId,
          //     'affiliation': '1checkout',
          //     'revenue': event.data.totalCartValue,
          //     'shipping': event.data.shippingCharges,
          //     'tax': event.data.totalTax
          //   });
          //   event.data.cartItemDetails.forEach(item => {
          //     ga('ecommerce:addItem', {
          //       'id': item.id,
          //       'name': item.name,
          //       'sku': item.sku,
          //       'category': '',
          //       'price': item.price,
          //       'quantity': item.quantity
          //     });
          //   });
          //   ga('ecommerce:send');
          // } catch (e) {
          //   console.warn('ga error for "Purchase"', e);
          // };
        } else if (event.data.message == 'create_abandoned_checkout') {
          // try {
          //   fetch(event.data.checkoutUrl)
          //     .then(response => {});
          // } catch (error) {};
          this.updateShopifyCustomerEventState({
            abandonedUrl: event.data.checkoutUrl || this.SHOPIFY_CUSTOMER_EVENTS.abandonedUrl,
          });

          try {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none"; // Hide the iframe
            iframe.src = event.data.checkoutUrl;
            iframe.id = "acIframe";
            document.body.appendChild(iframe);
          } catch (error) {
              console.error("Error loading iframe:", error);
          }
        } else if(event.data.message == 'create_ads_manager'){
          // let splitKey = event.data.send_to_key.split("/");
          // const script1 = document.createElement('script');
          // script1.src = `https://www.googletagmanager.com/gtag/js?id=${splitKey[0]}`;
          // script1.async = true;
          // document.head.appendChild(script1);
      
          // const script2 = document.createElement('script');
          // script2.innerHTML = `
          //   window.dataLayer = window.dataLayer || [];
          //   function gtag(){dataLayer.push(arguments);}
          //   gtag('js', new Date());
          //   gtag('config', '${splitKey[0]}');
          // `;
          // document.head.appendChild(script2);

          const ga = Array.isArray(event.data.ga_ids) ? event.data.ga_ids : [];
          const fb = Array.isArray(event.data.fb_ids) ? event.data.fb_ids : [];
          
          try {
            // console.log("adding ga measurement id script");
            // 1. Load gtag.js script
            ga.forEach((entry, index) => {
              const script = document.createElement('script');
              script.src = `https://www.googletagmanager.com/gtag/js?id=${entry.ga_measurement_id}`;
              script.async = true;
              document.head.appendChild(script);
            });
            const configLines = ga.map(entry => `gtag('config', '${entry.ga_measurement_id}', {
                allow_linker: true,
                linker: {domains: ['${window.location.hostname}','pay.1checkout.ai']},
                currency: 'INR'
              });`).join('\n');

            const script1 = document.createElement('script');
            script1.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag() { dataLayer.push(arguments); }
              window.gtag = gtag;
              gtag('js', new Date());
              ${configLines}
            `;
            if(ga.length > 0) {
              document.head.appendChild(script1);
            }
          } catch(err) {
            // console.log(err, "ga_measurement_id error");
          }

          try{
            // console.log("adding google ads script");
            ga.forEach((entry) => {
              if (!entry || typeof entry.gtag_send_to !== 'string' || entry.gtag_send_to.length === 0) {
                return;
              }
              let splitKey = entry.gtag_send_to.split("/");
              const sendToId = splitKey[0];

              const script = document.createElement('script');
              script.src = `https://www.googletagmanager.com/gtag/js?id=${sendToId}`;
              script.async = true;
              document.head.appendChild(script);
            });
            const firstSendTo = ga[0] && typeof ga[0].gtag_send_to === 'string' ? ga[0].gtag_send_to : '';
            const sendToId = firstSendTo ? firstSendTo.split("/")[0] : '';
            const script2 = document.createElement('script');
            script2.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${sendToId}');
            `;
            if(sendToId && sendToId !== "") {
              document.head.appendChild(script2);
            }
          } catch(err) {
            // console.log(err, "google ads error");
          }

          try {
            // console.log("adding fbq script");
            if(fb.length > 0) {
              // 1. Load Facebook Pixel base script
              const fbscript = document.createElement('script');
              fbscript.innerHTML = `
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
              `;
              document.head.appendChild(fbscript);
              
              const fbConfigLines = fb.map(entry => `fbq('init', '${entry.pixel_id}');`).join('\n');

              const script3 = document.createElement('script');
              script3.innerHTML = `
                ${fbConfigLines}
                fbq('track', 'PageView');
              `;
              document.head.appendChild(script3);
              
              fb.forEach(pixel => {
                const noscript = document.createElement('noscript');
                noscript.innerHTML = `
                  <img height="1" width="1" style="display:none"
                      src="https://www.facebook.com/tr?id=${pixel.pixel_id}&ev=PageView&noscript=1" />
                `;
                document.body.insertBefore(noscript, document.body.firstChild);
              });
            }
          } catch(err) {
            // console.log(err, "fbq script loading error")
          }

        } else if(event.data.message == "to_collect_ga_ids"){
          // let ga_measurement_id = event.data.ga_measurement_id;

          // (function waitForGa(measurementId, maxWait = 5000) {
          //   let resolved = false;
          
          //   // 1. Listen to every dataLayer push until we see the config for our stream
          //   window.dataLayer = window.dataLayer || [];
          //   const originalPush = dataLayer.push;
          //   dataLayer.push = function () {
          //     for (const arg of arguments) {
          //       if (arg && arg.event === 'config' && arg['send_to'] === measurementId) {
          //         fetchIds();
          //       }
          //     }
          //     return originalPush.apply(this, arguments);
          //   };
          
          //   // 2. Fallback timeout so we never hang forever
          //   const t = setTimeout(fetchIds, maxWait);
          
          //   function fetchIds() {
          //     if (resolved) return;
          //     resolved = true;
          //     clearTimeout(t);
          
          //     if (typeof gtag === "function") {
          //       gtag('get', measurementId, 'client_id', (cid) => {
          //         gtag('get', measurementId, 'session_id', (sid) => {
          //           postToIframe(cid, sid);
          //         });
          //       });
          //     }
          //   }
          
          //   function postToIframe(cid, sid) {
          //     const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
          //     iframe?.contentWindow.postMessage(
          //       { ga_client_id: cid, ga_session_id: sid, topic: '1CHECKOUTGADATA' },
          //       '*'
          //     );
          //   }
          // })(ga_measurement_id);

          let ga_measurement_id =
            typeof event.data.ga_measurement_id === "string"
              ? event.data.ga_measurement_id.trim()
              : "";

          function getCookie(name) {
            return document.cookie
              .split("; ")
              .find(row => row.startsWith(name + "="))
              ?.split("=")[1] || null;
          }

          function getGaClientIdFromCookie() {
            const ga = getCookie("_ga");
            const m = ga && ga.match(/^GA\d+\.\d+\.(\d+\.\d+)/);
            return m ? m[1] : null;
          }

          function getGaSessionIdFromCookie(measurementId) {
            if (!measurementId) {
              return null;
            }
            const name = "_ga_" + measurementId.replace("G-", "");
            const val = getCookie(name);
            const m = val && val.match(/^GS\d+\.\d+\.s(\d+)/);
            return m ? m[1] : null;
          }

          function collectGaIds(measurementId) {
            const fallbackCid = getGaClientIdFromCookie();
            const fallbackSid = getGaSessionIdFromCookie(measurementId);

            const post = (cid, sid) => {
              const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
              iframe?.contentWindow.postMessage(
                { ga_client_id: cid, ga_session_id: sid, topic: '1CHECKOUTGADATA' },
                '*'
              );
            };

            if (!measurementId) {
              return;
            }

            // Wait for gtag, but don't hang forever
            let tries = 0;
            const timer = setInterval(() => {
              tries += 1;
              if (typeof gtag === "function") {
                clearInterval(timer);
                gtag('get', measurementId, 'client_id', (cid) => {
                  gtag('get', measurementId, 'session_id', (sid) => {
                    post(cid || fallbackCid, sid || fallbackSid);
                  });
                });
              } else if (tries >= 20) { // ~5s
                clearInterval(timer);
                post(fallbackCid, fallbackSid);
              }
            }, 250);
          }

          collectGaIds(ga_measurement_id);
        } else if(event.data.message == 'redirect_to_shopify_checkout'){
          this.CHECKOUT_ERROR = true;
          this.triggerShopifyCheckout();
          setTimeout(()=>{
            this.resetCheckoutModalState({ removeIframe: true, clearCheckoutContext: true });
          }, 3000);
        } else if(event.data.message == 'order_url_redirection'){
          // The 'order_placed' message fires fbq('track', 'Purchase') just before
          // this one; navigating away immediately can cancel that beacon and lose
          // the browser-side Purchase. Give the pixel a moment to flush first.
          setTimeout(() => {
            window.location.replace(event.data.nextPage);
          }, 1000);
        } else if(event.data.message === 'open_razorpay'){
          function loadRazorpayModal(){
            const updatedConfig = { 
              ...event.data.rzpConfig, 
              handler: function (data) {
                  const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
                  
                  // Ensure iframe exists before posting message
                  if (iframe?.contentWindow) {
                      iframe.contentWindow.postMessage({ topic: 'RAZORPAYSUCCESS' }, '*');
                  } else {
                      // console.log("Iframe not found or inaccessible.");
                  }
          
                  // Clear cart using API request
                  ONE_CHECKOUT_UTIL.apiRequest(
                      'POST', 
                      '/cart/clear.js',
                      [['Content-Type', 'application/json; charset=UTF-8']], // Fix capitalization
                      {},
                      () => console.log("Cart cleared successfully."),
                      (err) => console.log("Error clearing cart:", err)
                  );
              }
            };
            const razorpay = new Razorpay(updatedConfig)
              .on("payment.failed", function (data) {
                iframe.contentWindow.postMessage({topic: 'RAZORPAYFAILURE'});
              })
              .on("payment.error", function (data) {
                iframe.contentWindow.postMessage({topic: 'RAZORPAYFAILURE'});
              });

            razorpay.open();
          }

          if (document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
            // console.log("Razorpay script already loaded.");
            loadRazorpayModal();
            return;
          }
      
          const script = document.createElement("script");
          script.src = "https://checkout.razorpay.com/v1/checkout.js";
          script.async = true;
          script.onload = function () {
              // console.log("Razorpay script loaded successfully.");
              loadRazorpayModal();
          };
      
          script.onerror = function () {
              // console.error("Failed to load Razorpay script.");
          };
      
          document.body.appendChild(script);
        }
      } else if (event.data.closeIframe) {
        let iframeUrlElem = document.querySelector(".checkoutmodal .iframe-container iframe");
        let url = new URL(iframeUrlElem.src);
        url.searchParams.set("payment_success", "failure");
        url.searchParams.set("pg_mode", "snapmint");
        iframeUrlElem.src = url;
      };
    };
  };

  pageLoad() {
    if (this.PAGE_LOADED) return;
    try{  
      fetch('https://pay.1checkout.ai/health');
      fetch('https://api.1checkout.ai/health');
    }catch{}
    this.PAGE_LOADED = true;
    this.bindPageLifecycleGuards();
    this.triggerWA1CheckoutOnPageLoad();

    // Registering event for availability check 
    try {
      document.querySelector('[name="id"]').addEventListener('change', function() {
        oneCheckout.checkVariantAvailability(parseInt(this.value));
      });
    } catch(e) {};

    if (['/cart', '/cart/'].includes(window.location.pathname) && this.REFRESH_CART) {
      // WA checkout will trigger init after cart is rebuilt
    }
  };

  variantChanged(event) {
    oneCheckout.checkVariantAvailability(event.detail.variant.id);
  };

};
// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //
// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //
var TARGET_BTNS_FOR_1C = [
  {
    target: 'cart_button',
    selector: 'form[action="/checkout"] div[data-layout="checkout"]',
    observeUrl: '/cart/add',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Checkout</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_button',
    selector: 'form[action="/checkout"] div[data-layout="checkout"]',
    observeUrl: '/cart/change',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Checkout</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_page_checkout_button',
    selector: 'form[action="/cart"] button.cart-page__checkout-btn[name="checkout"]',
    observeUrl: '/cart/add',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Checkout</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_page_checkout_button',
    selector: 'form[action="/cart"] button.cart-page__checkout-btn[name="checkout"]',
    observeUrl: '/cart/change',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Checkout</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_drawer_checkout_button',
    selector: '.cart-drawer__actions a[href="/checkout"]',
    observeUrl: '/cart/add',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Checkout</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_drawer_checkout_button',
    selector: '.cart-drawer__actions a[href="/checkout"]',
    observeUrl: '/cart/change',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Checkout</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'buy_now_button',
    selector: 'form[action="/cart/add"] div[data-shopify="payment-button"]',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.buyNow1Checkout(this)">
        <span class="btn-1checkout-title">Buy it now</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>
      <span id="buyNow1CheckoutError" class="dc-none">This item seems to be out of stock!</span>`
  },
  {
    target: 'buy_now_button',
    selector: 'form[action="/cart/add"] div[data-shopify="payment-button"]',
    observeUrl: '/products',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.buyNow1Checkout(this)">
        <span class="btn-1checkout-title">Buy it now</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>
      <span id="buyNow1CheckoutError" class="dc-none">This item seems to be out of stock!</span>`
  },
  {
    target: 'floating_buy_now_button',
    selector: 'button.product-floating-bar__btn[data-floating-btn="buy_now"]',
    observeUrl: '/products',
    dynamicBtn: `
      <span class="btn-1checkout-tag">Extra 5% Off on Prepaid Orders</span>
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.buyNow1Checkout(this)">
        <span class="btn-1checkout-title">Buy Now</span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>
      <span id="buyNow1CheckoutError" class="dc-none">This item seems to be out of stock!</span>`
  }
];

var oneCheckoutBtnRenderer = new OneCheckoutBtnRenderer(
  targetBtns = TARGET_BTNS_FOR_1C
);

document.querySelector('body').onload = function () {
  oneCheckoutBtnRenderer.pageLoad();
};
// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //


// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //
var oneCheckout = new OneCheckout();

// Browser messaging
window.addEventListener('message', function (event) {
  oneCheckout.messageListener(event);
}, false);

history.pushState(null, null, window.location.href);
const iframeUrlDiv = document.querySelector('.checkoutmodal .iframe-container');
const checkoutmodalInput = document.querySelector('.checkoutmodal-state');

window.addEventListener('popstate', function () {
  if (
    iframeUrlDiv &&
    iframeUrlDiv.childNodes.length > 0 &&
    iframeUrlDiv.childNodes[0].nodeName === 'IFRAME'
  ) {
    if (checkoutmodalInput.checked) {
      history.go(1);
      iframeUrlDiv.childNodes[0].contentWindow.postMessage(
        { topic: 'back-button-detection' },
        '*'
      );
    } else {
      history.go(-1);
    }
  } else {
    history.go(-1);
  }
}, false);

window.addEventListener('load', function () {
  oneCheckout.pageLoad();
});

// Registering optional event for availability check
document.addEventListener('variant:changed', function (event) {
  oneCheckout.variantChanged(event);
});

function checkoutModalToggled(el) {
  oneCheckout.checkoutModalToggled(el);
}
// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //